import styled from 'styled-components'
import { TEXT_GREY, CLICKABLE_COLOR } from '@CSSVars/colors'


export const _InfoHolderLocked = styled.div`
  position: relative;
  display: flex;
  line-height: 22px;
`

export const _InfoHolderDetail = styled.div`
  transition: all .5s;
  flex: 0 1 auto;

  line-height: 22px;
  color: ${TEXT_GREY};
`

export const _LockedCta = styled.div`
  cursor: pointer;
  pointer-events: all;

  color: ${CLICKABLE_COLOR};
  display: inline-block;
  &:hover{
    color: rgba(12,52,68,0.8);
  }
`
